import React, { useEffect, useRef } from 'react';
import { LEGAL_LINKS } from '../data/legalLinks';
import './Footer.css';

// Policy links on every screen. They open okiru.co.za in a new tab so a learner
// never loses their place in a course. In the app the footer sits below the
// scrolling content, so it never moves and never covers anything; its height
// is published as --site-footer-h so floating buttons can sit above it.
export default function Footer({ className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const root = document.documentElement;
    const publish = () => root.style.setProperty('--site-footer-h', `${Math.ceil(el.getBoundingClientRect().height)}px`);
    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(el);
    return () => { observer.disconnect(); root.style.removeProperty('--site-footer-h'); };
  }, []);

  return (
    <footer ref={ref} className={`site-footer ${className}`.trim()}>
      <nav aria-label="Legal and policies">
        <ul className="site-footer-links">
          {LEGAL_LINKS.map(link => (
            <li key={link.href}>
              <a href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}<span className="sr-only"> (opens in a new tab)</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <p className="site-footer-copy">&copy; {new Date().getFullYear()} Okiru (Pty) Ltd</p>
    </footer>
  );
}
